import React from "react"
import {Card} from "antd"
import {loadAppConfig} from "../../../config/app-config"
import {themeByClientKey} from "../../../theme/theme"

type Props = {
  children: React.ReactElement
}

export const WelcomeAccountPage: React.FC<Props> = ({
  children
}): React.ReactElement => {
  const appConfig = loadAppConfig()
  const { topLeftLogo, leftLogo, rightLogo, loginBackground, showTopLeftLogo } = themeByClientKey(appConfig.clientKey)
  const backgroundClassName = ["center", "container-sm", loginBackground].join(" ")

  return <>
    <div className={ backgroundClassName }>
      <div
        className={ topLeftLogo }
        style={{
          position: "absolute",
          top: "10px",
          left: "30px",
          width: 137,
          height: 77
        }}
        hidden={!showTopLeftLogo}/>

      <Card size="small" style={{borderRadius: 16, boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.25)", marginTop: 70}}
        className="card-login">
        <div className="logo-layout">
          <div className={ leftLogo }/>
          <div className={ rightLogo }/>
        </div>
        <br/>
        {children}
      </Card>

      <div className="footer">
        <div style={{color: "#8A8A8A"}}>version {appConfig.appVersion}</div>
        <br/>
      </div>
    </div>
  </>
}